import tree from "../../../components/tree.vue";
import iTable from "../../../components/Table.vue";
import IPagination from "../../../components/pagination.vue";
import cropperImg from "../../../components/cropperImg.vue"
import ImageEditor from '../../../components/ImageEditor.vue';
import { domainName } from "../../../utility/index"
import { selectDriverFace, updateDriverFace } from '../../../api/config/modules/DriverFaceFile'
export default {
    name: "DriverFaceFile",
    components: {
        tree,
        iTable,
        IPagination,
        cropperImg,
        ImageEditor
    },
    data() {
        return {
            // 当前编辑的行
            currentRow: null,
            // 图片编辑组件是否显示
            imageEditorVisible: false,
            // 当前图片URL
            currentImageUrl: '',


            isCollapse: false,
            stateArrow: true,
            isSearch: true,
            formInline: {
                driverNum: '',
                driverName: '',
                isFaceData: '',
                queryTime: '',
            },
            stateList: [
                { id: '', name: this.$t('common.all') },
                { id: '1', name: this.$t('DriverManagement.correct') },
                { id: '0', name: this.$t('DriverManagement.deny') },
            ],
            height: '550',
            list: [],
            option: {
                stripe: true,
                border: true,
                loading: false,
                highlightCurrentRow: false,
                mutiSelect: true,
                serialNumber: true,
            },
            columns: [{
                prop: "driverNum",
                label: this.$t('common.driverNum'),
                align: "center",
            },
            {
                prop: "driverName",
                label: this.$t('common.driverName'),
                align: "center",
            },
            {
                prop: "orgName",
                label: this.$t('common.orgName'),
                align: "center",

            },
            {
                prop: "faceUpdateTime",
                label: this.$t('DriverManagement.faceUpdateTime'),
                align: "center",
                // render: (h, params) => {
                //     return h('span', this.$formatTime(params.row.faceUpdateTime))
                // }
            },
            {
                label: this.$t('common.btn.operate'),
                align: "center",
                width: "120px",
                fixed: "right",
                render: (h, params) => {
                    return h('el-button',
                        {
                            props: {
                                type: 'primary', icon: params.row.faceFilePath === null ? '' : 'iconfont icontupian'
                            },
                            on: {
                                click: () => {
                                    // this.dialogOperateFormVisible = true
                                    this.getOperateList()
                                    this.$refs.table && this.$refs.table.$refs.mutipleTable.doLayout();
                                    // this.$set(this, 'imageUrl', params.row.faceFilePath);
                                    this.imageUrl = params.row.faceFilePath
                                }
                            }
                        })
                }
            },
            ],
            operates: {
                width: 100,
                fixed: "right",
                list: [
                    // {
                    //     id: '1',
                    //     show: true,
                    //     icon: 'iconfont icontupian',
                    //     plain: true,
                    //     disabled: false,
                    //     method: (index, row) => {
                    //         this.imageUrl = row.faceFilePath
                    //         this.dialogOperateFormVisible = true
                    //         this.getOperateList()
                    //     }
                    // }
                ]
            },
            currentPage: 1,
            pageSize: 10,
            total: 1,
            // 更新人脸数据
            dialogFormVisible: false,
            formLabelWidth: '100px',
            diaTitle: '',
            btnType: '',
            rules: {

            },
            form: {
                file: null,
                imageUrl: null,
            },
            file: null,
            processImg: '',
            FileList: [],
            imageUrl: '',
            selected: [],
            id: '',
            name: '',
            // 详情页面
            dialogOperateFormVisible: false,

            isDisable: false,
        }
    },
    // watch: {
    //     'form.imageUrl': {
    //         handler(newVal, oldVal) {
    //         console.log('form.imageUrl 变化:', { oldVal, newVal });
    //         },
    //         immediate: true
    //     }
    // },
    methods: {
        //左侧功能条切换
        toggleSideBar() {
            this.isCollapse = !this.isCollapse
            this.$store.dispatch('menuTab/toggleSideBar', this.isCollapse)
        },
        //上方功能条切换
        changeArrow() {
            this.stateArrow = !this.stateArrow
        },
        //查询
        initQuery(item) {
            this.id = item.id
            this.name = item.name
            this.selectList()
        },
        //树形图查询
        nodeClick(val) {
            this.id = val.label
            this.name = val.value
            this.selectList()
        },
        selectList() {
            let startTime = ''
            let endTime = ''
            if (this.formInline.queryTime) {
                if (this.formInline.queryTime.length > 0) {
                    startTime = this.formInline.queryTime[0]
                    endTime = this.formInline.queryTime[1]
                }
            }
            let param = {
                orgId: this.id,
                driverNum: this.formInline.driverNum,
                driverName: this.formInline.driverName,
                isFaceData: this.formInline.isFaceData,
                startTime: startTime,
                endTime: endTime,
                pageNum: this.currentPage,
                pageSize: this.pageSize,
            }
            this.$store.dispatch('DriverFaceFile/GET_SELECTDRIVERFACE', param).then(res => {
                if (res) {
                    console.log(res)
                    if (res.data.code == 200) {
                        this.list = res.data.data.list
                        this.$refs.page.CommandTotal = res.data.data.total
                    }
                }
            }).catch(err => { })
        },
        onSearch() {
            this.$refs.page.CommandCurrentPage = 1
            this.currentPage = 1
            this.selectList()
        },
        onClear() {
            this.formInline = {
                driverNum: '',
                driverName: '',
                isFaceData: '',
                startTime: '',
                endTime: '',
            }
            this.selectList()
        },
        updateDriverFace() {
            //     this.dialogFormVisible = true
            //     this.diaTitle = this.$t('common.btn.edit')

            //     this.$nextTick(() => {
            //         this.$refs.form.resetFields();
            //         if (this.selected && this.selected[0] && this.selected[0].faceFilePath) {
            //             const originalUrl = this.selected[0].faceFilePath;

            // // 只对非 blob URL 添加时间戳
            //             if (originalUrl.startsWith('blob:')) {
            //                 this.form.imageUrl = originalUrl;
            //             } else {
            //                 const timestamp = Date.now();
            //                 this.form.imageUrl = originalUrl.includes('?') 
            //                 ? `${originalUrl}&t=${timestamp}` 
            //                 : `${originalUrl}?t=${timestamp}`;
            //             }
            //         } else {
            //             this.form.imageUrl = ''; // 确保是空字符串
            //         }

            //         this.form.file = null
            //     })
            if (this.selected.length !== 1) {
                this.$message.warning(this.$t('DriverManagement.form.selectOneData'));
                return;
            }

            const targetRow = this.selected[0];
            this.currentRow = targetRow;
            this.currentImageUrl = targetRow.faceFilePath || '';
            this.imageEditorVisible = true;
        },
        // 处理图片编辑组件关闭
        handleImageEditorClose() {
            if (this.currentImageUrl?.startsWith('blob:')) {
                URL.revokeObjectURL(this.currentImageUrl);
            }
            this.imageEditorVisible = false;
            this.currentRow = null;
            this.currentImageUrl = '';
        },

        // 处理图片编辑组件取消
        handleImageEditorCancel() {
            this.handleImageEditorClose();
        },

        // 处理图片编辑组件确认（有新图片）
        handleImageEditorConfirm(file, imageUrl) {
            if (!this.currentRow) {
                this.$message.warning('请选择要编辑的行');
                return;
            }

            this.$set(this.currentRow, 'faceFilePath', imageUrl);

            // 调用后台接口上传图片
            this.uploadImageToServer(file, imageUrl);
        },

        // 处理图片编辑组件无变化
        handleImageEditorNoChange() {
            this.imageEditorVisible = false;
            this.$message.success('图片未变更');
        },

        // 上传图片到服务器
        uploadImageToServer(file, imageUrl) {
            // 创建FormData对象
            const formData = new FormData();
            formData.append('file', file); // 后台接收的文件字段名
            formData.append('driverNum', this.currentRow.driverNum);

            // 模拟调用后台接口
            //   this.$message.loading({
            //     message: '上传中...',
            //     duration: 0,
            //     forbidClick: true
            //   });

            // 实际项目中替换为真实的API调用
            this.$store.dispatch('DriverFaceFile/GET_UPDATEDRIVERFACE', formData).then(res => {
                this.$message.closeAll();
                if (res.data.code === 200) {
                    this.$set(this.currentRow, 'faceFilePath', imageUrl);
                    const rowIndex = this.list.findIndex(
                        item => item.driverNum === this.currentRow.driverNum
                    );
                    if (rowIndex !== -1) {
                        this.$set(this.list, rowIndex, { ...this.currentRow });
                    }
                    console.log(this.$refs.table)
                    this.$refs.table && this.$refs.table.$refs.mutipleTable.doLayout();
                    this.imageEditorVisible = false;
                    this.$message.success(this.$t('common.btn.editSuccess'));
                    this.selectList(); // 重新查询表格数据，确保同步
                } else {
                    this.$message.error(res.data.msg || '图片上传失败');
                }
            }).catch(err => {
                this.$message.closeAll();
                this.$message.error('上传出错：' + err.message);
            });

            // 实际API调用示例：
            /*
            this.$http.post('/api/upload-image', formData, {
              headers: {
                'Content-Type': 'multipart/form-data'
              }
            }).then(response => {
              if (response.data.success) {
                this.currentRow.imageUrl = response.data.imageUrl;
                this.imageEditorVisible = false;
                this.$message.success('图片上传成功');
              } else {
                this.$message.error('图片上传失败：' + response.data.message);
              }
            }).catch(error => {
              this.$message.error('上传出错：' + error.message);
            });
            */
        },

        // handleFileChange(file) {
        //     // console.log('event', event)
        //     this.form.file = file
        //     // this.form.imageUrl = URL.createObjectURL(file);
        //     if (file) {
        //        const previewUrl = URL.createObjectURL(file);
        //        this.form.imageUrl = previewUrl;
        //     } else {
        //        this.form.imageUrl = '';
        //     }
        //     this.$forceUpdate();
        //     // const file = event.target.files[0];
        //     // if (file) {
        //     //     this.form.file = file;
        //     //     // 读取文件内容，并将图片显示到页面上
        //     //     const reader = new FileReader();
        //     //     reader.onload = (e) => {
        //     //         this.form.imageUrl = e.target.result;
        //     //     };
        //     //     reader.readAsDataURL(file);
        //     // }
        // },
        // submitForm(formName) {
        //     console.log('file', this.form.file)
        //     // this.form.file = this.file
        //     let formData = new FormData();
        //     if (this.form.file) {
        //         formData.append('file', this.form.file);
        //     } else if (this.form.imageUrl && !this.form.imageUrl.startsWith('blob:')) {
        //         // 只处理非 blob 的 URL
        //         formData.append('imageUrl', this.form.imageUrl);
        //     } else {
        //         this.$message.error('请选择或上传图片');
        //         return;
        //     }
        //     // formData.append('file', this.form.file)
        //     formData.append('driverNum', this.selected[0].driverNum)
        //     console.log('formData', formData)
        //     this.$store.dispatch('DriverFaceFile/GET_UPDATEDRIVERFACE', formData).then(res => {
        //         if (res.data.code == 200) {
        //             this.$message.success(this.$t('common.btn.editSuccess'))
        //             this.dialogFormVisible = false;
        //             this.selectList();
        //             this.closeDia();
        //         } else {
        //             this.$message.error(res.data.msg)
        //         }

        //     }).catch(err => { })
        // },
        // cancel(formName) {
        //     this.dialogFormVisible = false;
        //     if (this.form.imageUrl && this.form.imageUrl.startsWith('blob:')) {
        //         URL.revokeObjectURL(this.form.imageUrl);
        //     }
        //     this.form = {
        //         file: null,
        //         imageUrl: '',
        //     }
        // },
        // closeDia() {
        //     this.dialogFormVisible = false;
        //     if (this.form.imageUrl && this.form.imageUrl.startsWith('blob:')) {
        //         URL.revokeObjectURL(this.form.imageUrl);
        //     }
        //     this.form = {
        //         file: null,
        //         imageUrl: null,
        //     }
        // },
        exportFile() {
            let startTime = ''
            let endTime = ''
            if (this.formInline.queryTime) {
                if (this.formInline.queryTime.length > 0) {
                    startTime = this.formInline.queryTime[0]
                    endTime = this.formInline.queryTime[1]
                }
            }
            if (domainName) {
                if (domainName.split(':')[0] !== 'localhost') {

                    let url = `https://${domainName}/v1/getExportExcel/exportDriverFace?orgId=${this.id}&driverNum=${this.formInline.driverNum}&driverName=${this.formInline.driverName}&isFaceData=${this.formInline.isFaceData}&startTime=${startTime}&endTime=${endTime}`
                    location.href = url

                } else {
                    let host = 'localhost:8080'
                    let url = `https://${host}/v1/getExportExcel/uploadDriverFinger?orgId=${this.id}&driverNum=${this.formInline.driverNum}&driverName=${this.formInline.driverName}&isFaceData=${this.formInline.isFaceData}&startTime=${startTime}&endTime=${endTime}`
                    location.href = url
                }
            }
        },
        //行选择
        handleSelectionChange(val) {
            this.selected = val
        },
        //换页
        changeSize(item) {
            this.pageSize = item.pageSize
            this.currentPage = item.pageNum
            this.selectList();
        },
        //查看详情
        getOperateList() {
            // this.$refs.table && this.$refs.table.doLayout();
            this.dialogOperateFormVisible = true
        },
        //关闭详情
        closeOperateDia() {
            this.imageUrl = null
            this.dialogOperateFormVisible = false
        },
        //行选择
        selectedChanged(val) {
            this.select = val
        },
        //下方切换表格
        changePageSize(item) {
            this.PageSize = item.pageSize
            this.CurrentPage = item.pageNum
            this.selectList();
        },
        onResize: function (x, y, width, height) {
            let box = document.getElementById("leftBox");
            box.style.width = width + "px";
        },
    }
}